<template>
  <div class="modal-card" style="width: auto; overflow: scroll;">
    <form method="post" @submit.prevent="onSend" novalidate>
      <header class="modal-card-head">
        <p class="modal-card-title is-centered">
          {{ $t('message.confirm_cancel_gift_review') }}
        </p>
      </header>

      <section class="modal-card-body">
        <form-wrapper :validator="$v.form">
          <form-group
            name="number"
            attribute="attributes.gift_application_cancel_number"
            :label="$t('attributes.gift_application_cancel_number')"
            label-position="on-border"
          >
            <b-input
              v-model="form.number"
              maxlength="20"
              :placeholder="
                $t('message.please_input_gift_review_cancel_number')
              "
              required
              expanded
            >
            </b-input>
          </form-group>
          <form-group
            name="date"
            attribute="attributes.gift_application_cancel_date"
            :label="$t('attributes.gift_application_cancel_date')"
            label-position="on-border"
          >
            <b-datepicker
              v-model="cancelDate"
              :placeholder="$t('message.please_input_gift_review_cancel_date')"
              icon="calendar-today"
              inline
              trap-focus
              required
              @input="onSelectedDate"
            >
              <div class="buttons">
                <b-button
                  :label="$t('attributes.today')"
                  type="is-success"
                  @click="onSelectedToday"
                />
                <b-button
                  :label="$t('attributes.yesterday')"
                  type="is-info"
                  @click="onSelectedYesterday"
                />
              </div>
            </b-datepicker>
          </form-group>
        </form-wrapper>
      </section>

      <footer class="modal-card-foot">
        <b-button
          :loading="sending"
          class="is-fullwidth"
          @click="$parent.close()"
        >
          {{ $t('attributes.close') }}
        </b-button>
        <b-button
          :loading="sending"
          type="is-primary"
          class="is-fullwidth"
          native-type="submit"
        >
          {{ $t('attributes.gift_review_cancel') }}
        </b-button>
      </footer>
    </form>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'ReviewCancelForm',

  props: {
    sending: {
      type: Boolean
    }
  },
  data() {
    return {
      cancelDate: null,

      form: {
        number: null,
        date: null
      }
    }
  },
  validations() {
    return {
      form: {
        number: { required },
        date: { required }
      }
    }
  },
  methods: {
    onSelectedToday() {
      this.cancelDate = this.$dayjs().toDate()
      this.form.date = this.formatDate(this.cancelDate)
    },
    onSelectedYesterday() {
      this.cancelDate = this.$dayjs()
        .subtract(1, 'day')
        .toDate()
      this.form.date = this.formatDate(this.cancelDate)
    },
    onSelectedDate(date) {
      this.form.date = this.formatDate(date)
    },

    onSend() {
      this.$v.$touch()

      if (this.$v.$invalid) {
        return
      }

      this.$emit('send', this.form)
    }
  }
}
</script>
